import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '@/utils/helpers';
import StatWidgetBox from './StatWidgetBox';
import { useGetBannersQuery } from '@/api/banners';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import { useSelector } from 'react-redux';
import TooltipStack from './partials/TooltipStack';
import TooltipContentContainer from './partials/TooltipContentContainer';

const BarrierTriggersChip = ({onClick, open}) => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner, isLoading } = useGetBannersQuery(activeBuildingId);
  const dayCount = banner?.gate_openings?.day_count;
  
  return (
    <StatWidgetBox
      icon={<LockOpenIcon sx={{ fontSize: 16 }} />}
      value={formatNumber(dayCount) || '-'}
      loading={isLoading}
      skeletonWidth={16}
      onClick={onClick}
      tooltipContent={open && <TooltipContent />}
    />
  );
};

const TooltipContent = () => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner } = useGetBannersQuery(activeBuildingId);
  const { t } = useTranslation();
  return (
    <TooltipContentContainer
      backgroundColor={'rgb(94, 53, 177)'}
      backgroundGradient={'rgb(69, 39, 160)'}
      icon={<LockOpenIcon sx={{ fontSize: 14, color: 'white' }} />}
      iconBackground={'rgb(69, 39, 160)'}
      title={t('barrier_triggers')}
    >
      <TooltipStack 
        items={[
          { label: t('month'), value: banner?.gate_openings?.month_count },
          { label: t('week'), value: banner?.gate_openings?.week_count },
          { label: t('day'), value: banner?.gate_openings?.day_count }
        ]}
        backgroundColor="rgb(255, 255, 255)"
        valueTransformFn={formatNumber}
      />
      
    </TooltipContentContainer>
  );  
}

export default BarrierTriggersChip;
